module.exports = __webpack_public_path__ + "media/images/pic/brodno/online_lessons_bg-49bb56da5c2088705ca71cfd6e12614b.png";